import React, { useState } from 'react';

import { SyncOutlined } from '@ant-design/icons';
import { Breadcrumb } from 'antd';
import styled from 'styled-components';

import Button from 'components/lib/Button';
import { useAppSelector } from 'store/hook';

import RingCentralCommunicationBackfillModal from './RingCentralCallLogBackfillModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;

const StyledBreadcrumb = styled(Breadcrumb)`
  span {
    color: var(--text-primary);

    &.fixed {
      color: var(--text-secondary);
    }
  }
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`;

const TitleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: var(--competitor-purple);
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 var(--box-shadow-pink);
`;

const TitleIconImage = styled.img`
  width: 20px;
  height: 20px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  font-size: 40px;
`;

const RingCentralRecordsHeader = () => {
  const [isBackfillModalOpen, setIsBackfillModalOpen] = useState(false);
  const { currentUser } = useAppSelector((state) => state.auth);

  return (
    <Container>
      <HeaderContent>
        <StyledBreadcrumb
          items={[
            {
              title: 'Mystery Shopping',
            },
          ]}
          separator="·"
        />
        <TitleRow>
          <TitleContainer>
            <TitleIcon>
              <TitleIconImage src="/icons/sms-black.svg" alt="RingCentral Records" />
            </TitleIcon>
            <Title>RingCentral Records</Title>
          </TitleContainer>
          {currentUser?.isSuperuser && (
            <Button type="primary" icon={<SyncOutlined />} onClick={() => setIsBackfillModalOpen(true)}>
              Ingest communications
            </Button>
          )}
        </TitleRow>
      </HeaderContent>
      <RingCentralCommunicationBackfillModal open={isBackfillModalOpen} onClose={() => setIsBackfillModalOpen(false)} />
    </Container>
  );
};

export default RingCentralRecordsHeader;
